const getLocalFromCode = (code) => {
  return code == 'de_DE' ? 'de' : 'en';
};

export default getLocalFromCode;
